import { memo, ReactNode } from 'react'
import cn from 'classnames'

interface IProps {
  children?: ReactNode
  className?: string
}

export const ListCardTable = memo<IProps>(function ListCardTable({ className, children }) {
  return <div className={cn('grid grid-cols-[120px_1fr] gap-x-2 gap-y-1 text-title-sm', className)}>{children}</div>
})
